<template>
  <div class="form-group">
    <label>{{ lang.get('entries.form.user.label') }}</label>
    <search-field
      name="entrant"
      :initial-id="id"
      :initial-value="name"
      src="/users/typeahead?name="
      value-property="name"
      :searching-label="lang.get('miscellaneous.searching')"
      @selected="storeUser"
    />
  </div>
</template>

<script>
import { SearchField } from 'vue-bootstrap';
import { mapMutations, mapState } from 'vuex';

export default {
  inject: ['lang'],
  components: {
    SearchField
  },
  computed: {
    ...mapState('entryForm', ['user']),
    id() {
      return this.user && this.user.id ? this.user.id.toString() : '';
    },
    name() {
      return this.user && this.user.name ? this.user.name : '';
    }
  },
  methods: {
    ...mapMutations('entryForm', ['storeUser'])
  }
};
</script>
